import { AlarmClock, ListChecks } from 'lucide-react';
import { formatIstDateTime } from '@gbv/utils';
import { Button, Modal } from '@gbv/ui';
import type { DueAlert } from './useDueAlerts';

/**
 * The one alert you cannot miss.
 *
 * Five and one minute out are toasts, which slide past whether or not anyone
 * looks. The deadline itself gets a dialog, because the whole reason someone
 * set a reminder is that they intended to be interrupted.
 */
export function DueNowDialog({
  alert,
  waiting,
  onDismiss,
}: {
  alert: DueAlert | null;
  waiting: number;
  onDismiss: () => void;
}) {
  const isTask = alert?.kind === 'task';

  return (
    <Modal
      open={Boolean(alert)}
      onOpenChange={(open) => !open && onDismiss()}
      title={isTask ? 'A task is due now' : 'Reminder'}
      description={alert ? formatIstDateTime(new Date(alert.at)) : undefined}
      footer={
        <div className="flex items-center justify-between gap-2">
          {/* Say how many are stacked up, so dismissing one does not look like
              it failed to close when the next appears in its place. */}
          <p className="text-[11px] text-ink-soft">{waiting > 0 && `${waiting} more waiting`}</p>
          <Button onClick={onDismiss}>Got it</Button>
        </div>
      }
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-danger-light text-danger">
          {isTask ? <ListChecks size={17} /> : <AlarmClock size={17} />}
        </span>
        <p className="text-[15px] font-semibold leading-snug text-ink">{alert?.title}</p>
      </div>
    </Modal>
  );
}
